import React from "react";
import { Box, Columns } from "@allxsmith/bestax-bulma";
import Figure from "../../Utils/Figure";


export default function FiguresDisplay({figuresLoaded, figuresData}){


    return (
        <Box>
            <Columns isMultiline>
                <Figure
                    label={"Total Value"}
                    loaded={figuresLoaded}
                    value={"£"+figuresData}
                />
            </Columns>
        </Box>
    );

}